/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React, { useMemo, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';

import Modal from '../Modal/Modal';
import Tabs from '../Tabs/Tabs';
import TabPanel from '../Tabs/TabPanel';
import Tab from '../Tabs/Tab';
import TabContent from '../Tabs/TabContent';
import TabContentItem from '../Tabs/TabContentItem';
import Search from './SearchDevice';
import { TextBlock } from '../index';

import styles from './CompatibleDevicesModal.module.scss';

const CompatibleDevicesModalEsim = ({
  active,
  setActive,
  devices,
  getItem,
  choose,
}) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [searchText, setSearchText] = useState('');
  const [notFound, setNotFound] = useState(false);
  const { t } = useTranslation();

  const devicesData = useMemo(() => {
    const result = devices?.map((item) => {
      const mutationData = item?.supportedDevicesResponseList?.filter((item) =>
        item?.name?.toLowerCase()?.includes(searchText?.toLowerCase()),
      );
      if (
        item?.supportedDevicesResponseList?.length > 0 &&
        mutationData?.length > 0
      ) {
        setActiveTab(item?.id);
      }

      searchText
        ? item?.name.toLowerCase()?.startsWith(searchText?.toLowerCase()) &&
          setActiveTab(item?.id)
        : setActiveTab(0);

      return { name: item?.name, supportedDevicesResponseList: mutationData };
    });

    if (
      result?.every((item) => item?.supportedDevicesResponseList?.length === 0)
    ) {
      setNotFound(true);
    } else {
      setNotFound(false);
    }

    return result;
  }, [devices, searchText]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTab = (item, index) => {
    return (
      <Tab
        className={classNames(styles.tab, {
          [styles.tab__notFound]: notFound && activeTab === index,
        })}
        key={index}
        onClick={() => {
          setActiveTab(index);
          setSearchText('');
        }}
      >
        {item?.name}
      </Tab>
    );
  };
  const renderListItem = (item, index) => {
    return (
      <div
        key={index}
        className={styles.item}
        onClick={() => {
          setSearchText(item?.name);
          choose && getItem(item?.name);
        }}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item?.name}
      </div>
    );
  };
  const renderTabContent = (item, index) => {
    return (
      <TabContentItem
        key={index}
        data-testid={'device-modal-content'}
        className={styles.content}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        {item?.supportedDevicesResponseList?.length > 0 ? (
          item?.supportedDevicesResponseList?.map(renderListItem)
        ) : (
          <TextBlock className={'text--large no-data'}>
            {t('esim:common.deviceNotFound')}
          </TextBlock>
        )}
      </TabContentItem>
    );
  };

  return (
    <Modal
      active={active}
      setActive={setActive}
      classNameInner={styles.modal}
      itemScope
      itemType='https://schema.org/Product'
    >
      <strong className={'title'}>
        {t('esim:checkout.modals.devices.title')}
      </strong>
      <Search
        onChange={(e) => {
          setSearchText(e);
        }}
        value={searchText}
      />
      <Tabs active={activeTab} onChange={handleChange}>
        <TabPanel className={styles.panel}>
          {devicesData?.map(renderTab)}
        </TabPanel>
        <TabContent>{devicesData?.map(renderTabContent)}</TabContent>
      </Tabs>
    </Modal>
  );
};

export default CompatibleDevicesModalEsim;
